<template>
    <div class="file-preview">
      <div v-if="isImageFile(file)">
        <img
          :src="file"
          alt="File preview"
          class="img-thumbnail"
          style="width: 100px; height: 100px; object-fit: cover;"
        />
      </div>
  
      <div v-else-if="isPdfFile(fileName)">
        <i class="fas fa-file-pdf text-danger" style="font-size: 40px;"></i>
      </div>
      <div v-else-if="isDocxFile(fileName)">
        <i class="fas fa-file-word text-primary" style="font-size: 40px;"></i>
      </div>
      <div v-else-if="isExcelFile(fileName)">
        <i class="fas fa-file-excel text-success" style="font-size: 40px;"></i>
      </div>
      <div v-else>
        <i class="fas fa-file text-secondary" style="font-size: 40px;"></i>
      </div>
  
      <a
        :href="file"
        :download="fileName"
        target="_blank"
        class="d-block mt-1 text-decoration-none text-primary"
      >
        Download
      </a>
    </div>
  </template>
  
  <script>
  export default {
    name: "FilePreview",
    props: {
      file: {
        type: String,
        required: true,
      },
    },
    computed: {
      fileName() {
        return this.getFileName(this.file);
      },
    },
    methods: {
      isImageFile(file) {
        const imageExtensions = /\.(jpg|jpeg|png|gif|bmp|svg)$/i;
        return imageExtensions.test(file);
      },
      isPdfFile(fileName) {
        return /\.pdf$/i.test(fileName);
      },
      isDocxFile(fileName) {
        return /\.(doc|docx)$/i.test(fileName);
      },
      isExcelFile(fileName) {
        return /\.(xls|xlsx)$/i.test(fileName);
      },
      getFileName(filePath) {
        return filePath.substring(filePath.lastIndexOf("/") + 1);
      },
    },
  };
  </script>
  
  <style>
  .file-preview {
    text-align: center;
  }
  </style>
  